import TextComponents from './Text.vue';

const version = {
    install:function(Vue) {
        Vue.component('version', TextComponents)
    }
}

export default version;